/* [D-817] OWNER 05.11: «аварійний запобіжник… щоб я міг на нього натиснути… всі обробки, які активні, повинні доробитися… бот не приймав у цей
   період їх відео… коли наступить тиша - внесення, по завершенню сповістити, що можуть продовжити… не спамити всіх юзерів».
   Кнопка «🛠 Технічна перерва» над чергою: стан, лічильники тиші (рахує сервер - bot/maint.py, без ШІ), увімкнути / вимкнути.
   Повідомлення юзерам шле cron n8n щохвилини (maint.py tick): «версії готові, зараз перерва» - лише тим, хто доробляв; «можна продовжувати» -
   лише тим, кому писали про перерву або хто пробував прийти. */
import React, { useEffect, useState } from 'react';
import { Box, Typography, Button, Dialog, DialogTitle, DialogContent, DialogActions } from '@mui/material';
import api from '../api';

const fmtT = (s) => { try { return new Date(s).toLocaleTimeString('uk-UA', { hour: '2-digit', minute: '2-digit' }); } catch (e) { return s || ''; } };

export default function MaintCard() {
  const [st, setSt] = useState(null);
  const [busy, setBusy] = useState(false);
  const [ask, setAsk] = useState(false);
  const [err, setErr] = useState('');
  const load = () => api.get('/maint').then(r => setSt(r.data || null)).catch(e => setErr((e.response && e.response.data && e.response.data.detail) || 'немає звʼязку'));
  useEffect(() => { load(); const iv = setInterval(load, 10000); return () => clearInterval(iv); }, []);   // eslint-disable-line -- [D-817]
  const set = (body) => { setBusy(true); setErr(''); api.post('/maint', body).then(r => setSt(r.data || null))
    .catch(e => setErr((e.response && e.response.data && e.response.data.detail) || 'помилка')).finally(() => { setBusy(false); setAsk(false); }); };
  if (!st) return err ? <Typography sx={{ color: '#f87171', fontSize: 12, mb: 1 }}>🛠 Перерва: {err}</Typography> : null;
  const d = st.state || {}, c = st.counts || {};
  const on = !!d.on;
  const row = (l, v, good) => (
    <Box sx={{ px: 1, py: .4, borderRadius: 1.5, bgcolor: 'rgba(255,255,255,.04)', fontSize: 12, color: good ? '#9fe9b0' : '#ddd' }}><b>{v}</b> {l}</Box>);
  return (
    <Box data-maint-card="1" sx={{ mb: 2, p: 1.6, borderRadius: 2.5, bgcolor: on ? 'rgba(255,209,102,.08)' : 'rgba(255,255,255,.03)',
                                   border: `1px solid ${on ? '#ffd166' : '#333'}` }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap' }}>
        <Typography sx={{ fontWeight: 800, color: on ? '#ffd166' : '#fff', fontSize: 15 }}>
          🛠 Технічна перерва: {on ? `УВІМКНЕНО з ${fmtT(d.since)}${d.eta_min ? ` (~${d.eta_min} хв)` : ''}` : 'вимкнено'}
        </Typography>
        <Box sx={{ flex: 1 }} />
        {!on && [10, 20, 30, 60].map(m => (
          <Button key={m} size="small" variant="outlined" disabled={busy} data-maint-on={m} onClick={() => set({ on: true, eta_min: m })}
            sx={{ textTransform: 'none', color: '#ffd166', borderColor: '#ffd166', fontSize: 12, py: .2 }}>Увімкнути · ~{m} хв</Button>))}
        {on && <Button size="small" variant="contained" disabled={busy} data-maint-off="1" onClick={() => setAsk(true)}
          sx={{ textTransform: 'none', bgcolor: '#00e5a0', color: '#04121a', fontWeight: 800, fontSize: 12.5 }}>✅ Вимкнути і написати «можна продовжувати» ({c.will_notify || 0})</Button>}
      </Box>
      {on && (
        <Box sx={{ display: 'flex', gap: .6, flexWrap: 'wrap', mt: 1 }}>
          {row('обробок', c.processing || 0, !c.processing)}{row('у редакторі', c.editor || 0, !c.editor)}
          {row('оплат карткою в дорозі', c.card_pay || 0, !c.card_pay)}{row('ще доробляють', c.finishing || 0, !c.finishing)}
          {row('прийшли під час перерви', c.blocked || 0, true)}
          {row(c.quiet_bot ? '✅ ТИША - можна викладати / перезапускати' : (c.quiet_workers ? '⏳ воркери вільні, бот ще чекає' : '⏳ чекаємо тиші'), '', !!c.quiet_bot)}
        </Box>)}
      <Typography sx={{ fontSize: 11.5, color: '#999', mt: 1, lineHeight: 1.45 }}>
        Увімкнено: хто зараз обробляє, у черзі чи редагує - доробляє й отримує версії, потім одне повідомлення про перерву; хто приходить з новим
        відео - коротка відповідь у боті, у Студії - напис (нікому більше не пишемо). Тиша - вам повідомлення в бот. Вимкнено - «можна продовжувати»
        лише тим, кому писали.
      </Typography>
      {err && <Typography sx={{ color: '#f87171', fontSize: 12, mt: .5 }}>{err}</Typography>}
      <Dialog open={ask} onClose={() => setAsk(false)}>
        <DialogTitle>Вимкнути технічну перерву?</DialogTitle>
        <DialogContent>Бот і Студія знову прийматимуть нові відео. «Можна продовжувати» отримають {c.will_notify || 0} люд. (лише ті, кому писали про перерву).</DialogContent>
        <DialogActions>
          <Button onClick={() => setAsk(false)}>Ні</Button>
          <Button onClick={() => set({ on: false })} disabled={busy} sx={{ color: '#00e5a0', fontWeight: 800 }}>Так, вимкнути</Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}
